var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 900,
    height: 600,
    fill: "#faeee8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffd8c5"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 95,
    cx: 542,
    cy: 370
  }), /*#__PURE__*/React.createElement("circle", {
    r: 36,
    cx: 297,
    cy: 287
  }), /*#__PURE__*/React.createElement("circle", {
    r: 63,
    cx: 233,
    cy: 489
  }), /*#__PURE__*/React.createElement("circle", {
    r: 62,
    cx: 898,
    cy: 323
  }), /*#__PURE__*/React.createElement("circle", {
    r: 53,
    cx: 840,
    cy: 586
  }), /*#__PURE__*/React.createElement("circle", {
    r: 80,
    cx: 200,
    cy: 37
  }), /*#__PURE__*/React.createElement("circle", {
    r: 72,
    cx: 790,
    cy: 115
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgHeader);
export default __webpack_public_path__ + "static/media/bg-header.a1b4346ffc3312e0fb71a4b4a9f75ce4.svg";
export { ForwardRef as ReactComponent };